import { Observable } from 'knockout';
import HeatmapViewType from '../enums/viewType';

export interface HeatmapViewLinkConfig {
    title: string
    type: HeatmapViewType
    isActive?: boolean
}

export default class HeatmapViewLink {
    title: Observable<string>
    type: Observable<HeatmapViewType>
    isActive: Observable<boolean>

    constructor(config: HeatmapViewLinkConfig) {
        this.title = ko.observable(config.title);
        this.type = ko.observable(config.type);
        this.isActive = ko.observable(config.isActive ?? false);
    }
}